import { render, staticRenderFns } from "./SaveDownloadSettingsModal.vue?vue&type=template&id=29dfe034"
import script from "./SaveDownloadSettingsModal.vue?vue&type=script&lang=js"
export * from "./SaveDownloadSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29dfe034')) {
      api.createRecord('29dfe034', component.options)
    } else {
      api.reload('29dfe034', component.options)
    }
    module.hot.accept("./SaveDownloadSettingsModal.vue?vue&type=template&id=29dfe034", function () {
      api.rerender('29dfe034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/SaveDownloadSettingsModal.vue"
export default component.exports